// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/starOutline.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Rating.css */
.stars-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.star {
  cursor: default;
  height: 1.5em;
  width: 1.5em;
}

.star img {
  max-height: 100%;
  max-width: 100%;
}

.star.gold {
  color: gold;
}

.star.clickable {
  cursor: pointer;
}

/* Use starOutlineIcon for the outline */
.star:not(.gold) img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Adjust the path as needed */
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Rating.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,gDAA4C,EAAE,8BAA8B;AAC9E","sourcesContent":["/* Rating.css */\n.stars-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.star {\n  cursor: default;\n  height: 1.5em;\n  width: 1.5em;\n}\n\n.star img {\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.star.gold {\n  color: gold;\n}\n\n.star.clickable {\n  cursor: pointer;\n}\n\n/* Use starOutlineIcon for the outline */\n.star:not(.gold) img {\n  content: url(\"../../assets/starOutline.svg\"); /* Adjust the path as needed */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
